/**
 * 用户信息store
 */
import { defineStore } from "pinia";

import { storage, GENDER_LIST } from "@/utils";
import { userInfoApi, getSettingApi } from "@/api";

export const useUserStore = defineStore({
  id: "user", // id必填，且需要唯一
  state: () => {
    return {
      token: storage.get("token") || "", // 登录token
      userInfo: storage.get("userInfo") || {}, // 用户信息
      systemSetting: {
        video: {},
        hasValue: false,
      }, // 基础配置
    };
  },
  actions: {
    // 用户信息接口
    async getUserInfo() {
      if (!storage.get("token")) {
        // 未登录
        return;
      }
      const res = await userInfoApi().catch((e) => e);
      if (res) {
        const { code, data } = res;
        if (code === 99999 && data) {
          data.genderText = GENDER_LIST[data.gender]; // 性别
          this.userInfo = data;
          storage.set("userInfo", data);
          return;
        }
      }
    },
    // 获取基础配置
    async getSetting() {
      if (!storage.get("token")) {
        // 未登录
        return;
      }
      if (!this.systemSetting.hasValue) {
        const res = await getSettingApi().catch((e) => e);
        if (res) {
          const { code, data } = res;
          if (code === 99999 && data) {
            this.systemSetting.video = JSON.parse(data.video);
            this.systemSetting.base = JSON.parse(data.base);
            this.systemSetting.hasValue = true;
          } else {
            this.systemSetting.hasValue = false;
            this.systemSetting.video = {};
            this.systemSetting.base = {};
          }
        } else {
          this.systemSetting.hasValue = false;
          this.systemSetting.video = {};
          this.systemSetting.base = {};
        }
      }
      return this.systemSetting;
    },
  },
});
